export const getUserDisplayName = (user) => {
  if (!user) return { name: 'User', isOrganization: false };
  
  // Use accountType from new schema to determine if it's an organization
  const isOrganization = user.accountType === 'organization';
  
  // For organization accounts, display the organization name
  // For individual accounts, display the user name
  let displayName = 'User';
  
  if (isOrganization) {
    // For org accounts, handle both object and string formats
    if (typeof user.organization === 'object' && user.organization?.name) {
      displayName = user.organization.name;
    } else if (typeof user.organization === 'string') {
      displayName = user.organization;
    } else {
      displayName = user.name || 'Organization';
    }
  } else {
    // For individual accounts, use name
    displayName = user.name || 'User';
  }
  
  return { name: displayName, isOrganization };
};

export const getUserInitials = (user) => {
  if (!user) return 'U';
  
  const displayName = getUserDisplayName(user).name;
  if (!displayName || typeof displayName !== 'string') return 'U';
  
  const nameParts = displayName.split(' ');
  
  if (nameParts.length >= 2) {
    return `${nameParts[0][0]}${nameParts[1][0]}`.toUpperCase();
  }
  return nameParts[0][0].toUpperCase();
};
